import { z } from 'zod'
import { EndDate, Id, IsActive, StartDate, UpdateDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace RoomType {
  export interface Data {
    /** @description Type identifier (key) */
    readonly id: number

    /** @description Name */
    readonly name: string

    /** @description Short name */
    readonly shortName?: string

    /** @description Description */
    readonly description?: string

    /** @description Record update date */
    readonly updatedAt: Date

    /** @description Record start date */
    readonly startDate: Date

    /** @description Record end date */
    readonly endDate: Date

    /** @description Activity status */
    readonly isActive: boolean
  }
}

/** @description Room type */
export class RoomType extends GarItem<'RoomType', RoomType.Data> {
  static readonly SCHEMA: GarItem.Schema<RoomType.Data> = z
    .strictObject({
      ID: Id,

      NAME: z.string().describe('Name'),

      SHORTNAME: z.string().optional().describe('Short name'),

      DESC: z.string().optional().describe('Description'),

      UPDATEDATE: UpdateDate,

      STARTDATE: StartDate,

      ENDDATE: EndDate,

      ISACTIVE: IsActive,
    })
    .transform<RoomType.Data>(attributes => ({
      id: attributes.ID,
      name: attributes.NAME,
      shortName: attributes.SHORTNAME,
      description: attributes.DESC,
      updatedAt: attributes.UPDATEDATE,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
      isActive: attributes.ISACTIVE,
    }))

  readonly type = 'RoomType'

  protected get schema() {
    return RoomType.SCHEMA
  }
}
